import { NextPage } from 'next';
import { useTranslation } from 'react-i18next';

import Layout from 'modules/layout';
import AboutUsContent from 'modules/static-pages/components/AboutUsContent';
import { getBasicStaticProps } from 'utils/page';

const AboutPage: NextPage = () => {
  const {
    i18n: { language },
    t,
  } = useTranslation('about');

  return (
    <Layout
      language={language}
      seo={{
        description: t('meta.description'),
        keywords: 'Zehitomo, About',
        ogDescription: t('meta.description'),
        ogImage:
          'https://res.cloudinary.com/zehitomo/image/upload/v1652747398/assets/openGraphLogo.png',
        ogTitle: t('meta.ogTitle'),
      }}
      title={t('meta.title')}
    >
      <AboutUsContent />
    </Layout>
  );
};

export const getStaticProps = getBasicStaticProps(['about']);

export default AboutPage;
